import axios from 'axios';
import { KIT_API_BASE_URL, getPartner } from '../../constants';
import { KitStatus, LatestKitsPayload, Kit } from '../../models/customerOverview';
import { KitOverviewResponse } from '../../containers/Customers/component/Dial';

export class KitService {

  static fetchLatestKits() {
    return KitService.fetchKits();
  }

  static async fetchKits(from?: number, size?: number, status?: KitStatus): Promise<LatestKitsPayload> {
    const partner = getPartner();
    let url = typeof from !== 'undefined' && typeof size !== 'undefined'
      ? `${KIT_API_BASE_URL}/v2.0/kit?tests=true&partner=${partner}&from=${from}&size=${size}`
      : `${KIT_API_BASE_URL}/v2.0/kit?tests=true&partner=${partner}`;

    if (status === 'report-ready' || status === 'report-result-ready') {
      url += `&status=ready&testStatus=${status}`;
    } else if (status) {
      url += `&status=${status}`;
    }
    const response = await axios.get<LatestKitsPayload>(url);
    return response.data;
  }

  static async fetchKitsByStatus(from?: number, size?: number, status?: KitStatus): Promise<Kit[]> {
    const partner = getPartner();
    let url = typeof from !== 'undefined' && typeof size !== 'undefined'
      ? `${KIT_API_BASE_URL}/v1.0/kit?tests=true&partner=${partner}&from=${from}&size=${size}`
      : `${KIT_API_BASE_URL}/v1.0/kit?tests=true&partner=${partner}`;

    if (status) {
      url += `&status=${status}`;
    }
    const response = await axios.get<Kit[]>(url);
    return response.data;
  }

  static async fetchKitByBarcode(barcode: string): Promise<Kit | undefined> {
    const url = `${KIT_API_BASE_URL}/v1.0/barcode/${barcode}?verbose=true&showall=true&partner=${getPartner()}`;
    try {
      const response = await axios.get<Kit>(url);
      return response.data;
    } catch {
      return;
    }
  }

  static async fetchKitsOverViewresponse(): Promise<KitOverviewResponse> {
    const url = `${KIT_API_BASE_URL}/v1.0/overview/kit?partner=${getPartner()}`;
    const response = await axios.get<KitOverviewResponse>(url);
    return response.data;
  }
  static async fetchKitByKitId(kitId: string): Promise<Kit | undefined> {
    const url = `${KIT_API_BASE_URL}/v1.0/kit/${kitId}?verbose=true`;

    try {
      const response = await axios.get<Kit>(url);
      return response.data;
    } catch {
      return;
    }
  }

  static async fetchKitsByProfileIds(profileIds: string[]): Promise<Kit[]> {
    if (profileIds.length === 0) return [];

    const url = `${KIT_API_BASE_URL}/v1.0/kit?verbose=true&profileId=${profileIds.join(',')}`;

    try {
      const response = await axios.get<Kit[]>(url);
      return response.data;
    } catch {
      return [];
    }
  }
}
